"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Demo = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var material_1 = require("@mui/material");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var Pre_1 = require("./Pre/Pre");
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var Panel_1 = require("../../Panel");
var useStyles = (0, makeStyles_1.default)(function (t) { return (0, createStyles_1.default)({
    root: {
        boxShadow: t.shadows[1],
        borderRadius: 4,
        background: t.palette.background.default,
        overflow: 'auto',
        marginTop: t.spacing(2),
        marginBottom: t.spacing(3),
    },
    head: {
        margin: t.spacing(1) + " " + t.spacing(2) + " " + t.spacing(1 / 2) + " " + t.spacing(2),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    wrapper: {
        margin: t.spacing(1),
        padding: t.spacing(2),
        background: t.palette.background.paper,
    }
}); });
var parseComponentCode = function (code) { return code.replace(/\n\s*\/\/\s*@ts-ignore\s*?\n/, '\n'); };
var Demo = function (_a) {
    var Component = _a.component, raw = _a.raw, reloadable = _a.reloadable;
    var classes = useStyles();
    var _b = (0, react_1.useState)(false), codeOpened = _b[0], setCodeOponed = _b[1];
    var _c = (0, react_1.useState)(true), show = _c[0], setShow = _c[1];
    var _d = (0, react_1.useState)(undefined), containerHeight = _d[0], setContainerHeight = _d[1];
    var componentContainer = React.createRef();
    var reload = function () {
        // Manually handle container height is relevant when to prevent the
        // container to blink when the content is animated.
        if (!containerHeight) {
            setContainerHeight(componentContainer.current.offsetHeight - 32);
        }
        setShow(false);
        setTimeout(function () { return setShow(true); });
        setTimeout(function () { return setContainerHeight(undefined); });
    };
    return (React.createElement(Panel_1.Panel, null,
        React.createElement("div", { className: classes.head },
            reloadable &&
                React.createElement(material_1.IconButton, { disabled: !show, onClick: reload, size: "large" },
                    React.createElement(material_1.Icon, null, "refresh")),
            React.createElement(material_1.IconButton, { color: codeOpened ? 'primary' : undefined, onClick: function () { return setCodeOponed(!codeOpened); }, size: "large" },
                React.createElement(material_1.Icon, null, "code"))),
        React.createElement(material_1.Collapse, { in: codeOpened, unmountOnExit: true },
            React.createElement(Pre_1.Pre, { raw: parseComponentCode(raw), style: { margin: 0, borderRadius: 0 } })),
        React.createElement("div", { className: classes.wrapper, ref: componentContainer, style: { height: containerHeight } }, show && React.createElement(Component, null))));
};
exports.Demo = Demo;
//# sourceMappingURL=Demo.js.map